import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Play } from 'lucide-react';
import { motion } from 'motion/react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const HeroSection = () => {
  const [content, setContent] = useState<any>({
    homeHeroTitle: 'Cuidando com Amor e Dedicação em Iguatemi.',
    homeHeroSubtitle: 'A UNIFIG oferece fisioterapia, hidroterapia, equoterapia e muito mais para transformar a vida de pessoas com deficiência.'
  });

  useEffect(() => {
    const fetchContent = async () => {
      if (!db) return;
      try {
        const docRef = doc(db, 'content', 'pages');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContent(docSnap.data());
        }
      } catch (error) {
        console.error("Error fetching hero content:", error);
      }
    };
    fetchContent();
  }, []);

  return (
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full -z-10">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-blue-100/50 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-blue-50/50 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="inline-flex items-center space-x-2 bg-blue-50 text-primary px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide uppercase">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              <span>Atendimento Multidisciplinar Gratuito</span>
            </div>

            <h1 className="text-5xl lg:text-7xl font-extrabold text-slate-900 leading-[1.1] tracking-tight">
              {content.homeHeroTitle}
            </h1>

            <p className="text-lg lg:text-xl text-slate-600 leading-relaxed max-w-xl">
              {content.homeHeroSubtitle}
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Link
                to="/atividades"
                className="bg-primary text-white px-8 py-4 rounded-2xl font-bold flex items-center space-x-2 hover:bg-blue-800 transition-all shadow-xl shadow-blue-900/20 active:scale-95 group"
              >
                <span>Ver Atividades</span>
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/contato"
                className="bg-white text-slate-900 border border-slate-200 px-8 py-4 rounded-2xl font-bold flex items-center space-x-2 hover:bg-slate-50 transition-all active:scale-95"
              >
                <span>Fale Conosco</span>
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl shadow-blue-900/10">
              <img
                src="https://i.postimg.cc/CxWrLgLc/Whats-App-Image-2026-03-11-at-16-07-13.jpg"
                alt="Impacto Social"
                className="w-full h-full object-cover"
                referrerPolicy="no-referrer"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
